import React from "react";
import { Field, Form } from "react-final-form";
import { FormattedMessage } from "react-intl";
import InputField from "components/InputField/InputField";
import CheckboxField from "components/CheckboxField/CheckboxField";
import { loginAction } from "services/login/login.action";
import Button from "components/Button/Button";
import Styled from "./styled/StyledLoginForm";
import StyledFormRow from "components/styled/StyledFormRow.js";
import { useDispatch } from "react-redux";
import { standardInputStyles } from "@/components/common/inputStyles";
import FormInput from "@/components/InputField/FormInput";

const LoginForm = () => {
  const dispatch = useDispatch();

  const validate = (values) => {
    const errors = {};
    if (!values.identifier) {
      errors.identifier = "Required";
    }
    if (!values.password) {
      errors.password = "Required";
    }
    return errors;
  };

  return (
    <Styled.LoginBlock>
      <Form
        onSubmit={(values) => {
          dispatch(loginAction(values));
        }}
        validate={validate}
        render={({ handleSubmit }) => (
          <form
            onSubmit={handleSubmit}
            autoComplete="on"
            name="loginForm"
            method="post"
            action=""
          >
            <StyledFormRow>
              <FormInput type="email" name="identifier" label="Login.Email" />
            </StyledFormRow>
            <StyledFormRow>
              <FormInput
                type="password"
                name="password"
                label="Login.Password"
              />
            </StyledFormRow>

            <Styled.Remember>
              <CheckboxField name="rememberMe">
                <FormattedMessage id="Login.Remember" />
              </CheckboxField>
            </Styled.Remember>

            <Button htmlType="submit" uitype="login">
              <FormattedMessage id="Login.Button" />
            </Button>
          </form>
        )}
      />
    </Styled.LoginBlock>
  );
};

export default LoginForm;
